/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';

export const CreditLevelLabels = { pageTitle: 'Credit Levels' };

export const CreditLevelList = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField source="description" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const CreditLevelEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="Title" />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const CreditLevelCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const CreditLevelShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
